import { colors } from '@flowwai-frontend/shared/style-guide'

export const leadDistributionTheme = {
   // #region - light theme config
   light: {
      agentAllocationStep: {
         chevronIconColor: colors['gray-500'],
         leadBucketCardHeaderBorderColor: 'border-gray-300',
         leadBucketNameColor: 'text-gray-800'
      },
      agentGroups: {
         agentGroupsListAccessDenied: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            groupNameColor: 'text-gray-700',
            borderColor: 'border-gray-300'
         },
         agentGroupsView: {
            borderColor: 'border-gray-300'
         },
         createGroup: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         },
         groupCard: {
            containerBGColor: `bg-base-white hover:bg-gray-50`,
            containerBorderColor: `border-gray-300`,
            createdAtTextColor: `text-gray-600`,
            titleTextColor: `text-gray-700`
         },
         noAgentGroups: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-500'
         }
      },
      recordBuckets: {
         recordBucketBorderColor: 'border-gray-300',
         sortAppliedTextColor: 'text-gray-700',
         overrideSortTextColor: 'text-gray-700',
         clearConfirmation: {
            heading: 'text-gray-900',
            description: 'text-gray-600'
         }
      },
      arithmeticOperator: {
         operatorTextColor: 'text-gray-900',
         background: 'bg-base-white',
         disabledBackground: 'bg-gray-50',
         borderColor: 'border-gray-300 ',
         plusIconFillColor: colors['gray-500'],
         minusIconFillColor: colors['gray-500'],
         playUpIconFillColor: colors['gray-400'],
         playDownIconFillColor: colors['gray-300']
      },
      common: {
         accessDeniedDescriptionColor: 'text-gray-600',
         accessDeniedTitleColor: 'text-gray-900',
         addButtonPlusIconWhiteColor: colors['base-white'],
         addButtonPlusIconPrimaryColor: colors['primary-600'],
         backButtonChevronIconColor: colors['primary-600'],
         chevronIconFillColor: colors['gray-700'],
         nextButtonRightNarrowIconColor: colors['base-white'],
         stepDescriptionColor: 'text-gray-700',
         stepTitleColor: 'text-gray-900',
         totalEntitiesCountColor: 'text-gray-800',
         totalEntitiesDescriptionColor: 'text-gray-500',
         totalPeopleCountColor: 'text-gray-700'
      },

      configuredRDSummary: {
         borderColor: 'border-gray-300'
      },

      createRecordDistributionRule: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600 ',
         tickIconColor: colors['primary-600'],
         customOptionHoverBgColor: 'hover:bg-gray-50',
         selectedSalesPipelineBgColor: 'bg-gray-50',
         selectedBGColor: 'bg-primary-50',
         eventTypeLabelColor: 'text-gray-700',
         eventTypeDescriptionColor: 'text-gray-600',
         summaryLabelColor: 'text-gray-500',
         summaryValueColor: 'text-gray-800'
      },
      dsNotificationSettings: {
         headerTextColor: 'text-gray-800',
         description: 'text-gray-700',
         assigneeTextColor: 'text-gray-800',
         notificationSettingsBorderColor: 'bg-gray300'
      },

      distributionSettingsStep: {
         primaryTextColor: 'text-gray-800',
         secondaryTextColor: 'text-gray-700',
         sectionBorderColor: 'border-gray-300'
      },
      filterAction: {
         actionItemHoverColor: 'hover:bg-gray-50',
         actionItemTextColor: 'text-gray-900',
         deleteTextColor: 'text-error-600',
         dividerColor: 'border-gray-200',
         dotsVerticalIconColor: colors['gray-500'],
         filterActionMenuBgColor: 'hover:bg-gray-50',
         chevronIconFillColor: colors['gray-500']
      },
      executionLogs: {
         executionLogNameTextColor: 'text-gray-600',
         executionLogPipeTextColor: 'text-gray-600',
         executionLogDateTextColor: 'text-gray-600',
         executionLogDetailedViewModal: {
            headingTextColor: 'text-gray-800',
            closeIconColor: 'text-gray-500',
            countIcon: 'text-gray-500'
         }
      },

      pipelineItemCard: {
         pipelineNameTextColor: 'text-gray-700',
         cardHoverColor: 'hover:bg-gray-50',
         selectedCardBorderColor: 'border-primary-600',
         cardBorderColor: 'border-gray-300'
      },

      recordDistributionHeader: {
         titleTextColor: 'text-gray-900',
         addButtonColor: 'text-base-white',
         plusIconFillColor: colors['base-white'],
         header: 'bg-base-white border-gray-300'
      },

      scheduledDistributionRule: {
         activeChevronIconFillColor: colors['success-500'],
         inactiveChevronIconFillColor: colors['gray-500'],
         activeStatusBgColor: 'bg-success-50',
         inactiveStatusBgColor: 'bg-gray-50',
         statusItemHoverColor: 'hover:bg-gray-50',
         statusItemTextColor: 'text-gray-700'
      },

      sectionCard: {
         borderColor: colors['gray-300'],
         itemNameColor: 'text-gray-500',
         leadsLimitValueColor: 'text-gray-700',
         separatorBgColor: 'bg-gray-300'
      },

      stepSummarySection: {
         borderColor: colors['gray-300'],
         editIconColor: colors['primary-600'],
         groupItemValueColor: 'text-gray-700',
         itemNameColor: 'text-gray-500',
         itemValueColor: 'text-gray-800',
         sectionGroupItemLabelColor: 'text-gray-800',
         sectionTitleColor: 'text-gray-800',
         titleQuoteBorderColor: 'bg-primary-600',
         separatorBgColor: 'bg-gray-300'
      },
      agentAllocationQuotaCard: {
         cardBorderColor: colors['gray-300']
      },
      toggleOperator: {
         borderColor: 'border-gray-100',
         backgroundColor: 'bg-gray-50',
         color: 'text-gray-500',
         selectedBgColor: 'bg-base-white',
         selectedColor: 'text-gray-700',
         horizontalLineColor: 'border-gray-300'
      },
      managerAssignee: {
         titleColor: 'text-gray-800',
         descriptionColor: 'text-gray-700',
         sectionBorderColor: 'border-gray-300',
         plusIconColor: colors['primary-600'],
         disabledPlusIconColor: colors['gray-300']
      },
      deleteManagerAssignee: {
         deleteIconColor: colors['error-700']
      },
      rdLogs: {
         headerBorderColor: 'border-gray-300',
         headerTitleColor: 'text-gray-900',
         detailedView: {
            common: {
               headerTextColor: 'text-gray-800',
               dataTimeTextColor: 'text-gray-600',
               clockIconColor: colors['gray-700'],
               closeIconColor: colors['gray-500']
            },
            successCard: {
               cardBorderColor: 'border-gray-300',
               headingBorderBGColor: 'bg-primary-600',
               headingTextColor: 'text-gray-800',
               infoContentTextColor: 'text-gray-600',
               labelTextColor: 'text-gray-500',
               linkIconColor: colors['primary-600'],
               verticalDividerBGColor: 'bg-gray-300',
               usersContainerColors: 'bg-gray-50 border-gray-300',
               assigneeLabelTextColor: 'text-gray-700'
            },
            fallBackCard: {
               headingTextColor: 'text-gray-700',
               cardBorderColor: 'border-gray-300'
            },
            inProgressCard: {
               prefixIconBGColor: 'bg-primary-100',
               prefixIconBorderColor: 'border-primary-50',
               flipBackwardIconBGColor: colors['primary-600'],
               descriptionTextColor: 'text-gray-600',
               headerTextColor: 'text-gray-900'
            }
         }
      },
      leadSort: {
         leadSortCardBorderColor: 'border-gray-300',
         sortTextColor: 'text-gray-700',
         switchVerticalIcon: colors['gray-500']
      }
   },
   // #endregion

   // #region - light theme config
   dark: {}
   // #endregion
}
